import React from "react";
import { Image } from "react-bootstrap";
import styles from "./emptyMessage.module.scss";
import cx from "classnames";

export const EmptyMessage = ({src, message, className}) => {

  return (
    <div className={cx(styles.emptyMessage, className)}>
      <Image src={src} alt="No information" className={styles.image} />
      <div className={styles.message}>{message}</div>
    </div>
  )
}